import { render, staticRenderFns } from "./VlastLogoFull.vue?vue&type=template&id=4a35e91a"
import script from "./VlastLogoFull.vue?vue&type=script&lang=js"
export * from "./VlastLogoFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports